wbApp.controller('MyActivitiesExcuseCtrl', ['$scope', 'activityAttendanceSvc', 
function ($scope, activityAttendanceSvc) {

    $scope.isSaving = false;

    $scope.shouldDisableFirstPeriodExcuse = function (excuseModal) {
        if (moment(excuseModal.fromDate).isSame(moment(excuseModal.toDate), "day")) {
            return excuseModal.scheduleOrig.shouldDisableFirstPeriodExcuse;
        } else {
            return false;
        }
    }

    $scope.onDateChanged = function () {
        $scope.maxDate = moment($scope.excuseModal.toDate).endOf('day').toDate();
        $scope.minDate = moment($scope.excuseModal.fromDate).startOf('day').toDate();
    }

    $scope.onDateChanged();

    $scope.shouldDisableSecondPeriodExcuse = function (excuseModal) {
        if (moment(excuseModal.fromDate).isSame(moment(excuseModal.toDate), "day")) {
            return excuseModal.scheduleOrig.shouldDisableSecondPeriodExcuse;
        } else {
            return false;
        }
    }

    $scope.shouldShowAMExcuseMessage = function (excuseModal) {
        return (!excuseModal.period.am && !$scope.shouldDisableFirstPeriodExcuse(excuseModal)) &&
                (excuseModal.period.pm || $scope.shouldDisableSecondPeriodExcuse(excuseModal));
    }

    $scope.shouldShowPMExcuseMessage = function (excuseModal) {
        return (excuseModal.period.am ||  $scope.shouldDisableFirstPeriodExcuse(excuseModal)) &&
              (!excuseModal.period.pm && !$scope.shouldDisableSecondPeriodExcuse(excuseModal));
    }

    $scope.shouldShowAMPMExcuseMessage = function (excuseModal) {
        return (!excuseModal.period.am && !$scope.shouldDisableFirstPeriodExcuse(excuseModal)) &&
               (!excuseModal.period.pm && !$scope.shouldDisableSecondPeriodExcuse(excuseModal));
    }

    $scope.isOkDisabled = function (modal) {
        if (!modal || !modal.period) {
            alert('Error');
        }

        return !$scope.shouldShowAMExcuseMessage(modal) &&
               !$scope.shouldShowPMExcuseMessage(modal) &&
               !$scope.shouldShowAMPMExcuseMessage(modal);
    }

    $scope.onAttendanceExcuseConfirmClick = function (excuseModal) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        var a = activityAttendanceSvc.excuseStudent(
            $scope.selectedActivity.activityID,
            $scope.selectedStudent.studentID,
            moment(excuseModal.fromDate).startOf('day').toDate(),
            moment(excuseModal.toDate).endOf('day').toDate(),
            !excuseModal.period.am,
            !excuseModal.period.pm,
            excuseModal.notes);
        a.$promise.then(function (data) {
            var newAttendanceByActivityScheduleID = _.keyBy(data, 'activityScheduleID');

            _.forEach($scope.scheduleMonths, function (month) {
                for (var s = 0; s < month.schedules.length; s++) {
                    var schedule = month.schedules[s];
                    var newSchedule = newAttendanceByActivityScheduleID[schedule.activityScheduleID];
                    if (!!newSchedule) {
                        var differs =
                            schedule.firstPeriodAttendanceTypeID !== newSchedule.firstPeriodAttendanceTypeID ||
                            schedule.firstPeriodAttendanceStatusID !== newSchedule.firstPeriodAttendanceStatusID ||
                            schedule.firstPeriodAttendanceTypeID !== newSchedule.firstPeriodAttendanceTypeID ||
                            schedule.secondPeriodAttendanceStatusID !== newSchedule.secondPeriodAttendanceStatusID ||
                            schedule.numberOfExcuses !== newSchedule.numberOfExcuses ||
                            schedule.firstPeriodFilled !== newSchedule.firstPeriodFilled ||
                            schedule.secondPeriodFilled !== newSchedule.secondPeriodFilled ||
                            schedule.firstPeriodWaitQueuePosition !== newSchedule.firstPeriodWaitQueuePosition ||
                            schedule.secondPeriodWaitQueuePosition !== newSchedule.secondPeriodWaitQueuePosition;

                        if (differs) {
                            month.schedules[s] = newSchedule;
                        }
                    }
                }
            });

            for (var s = 0; s < $scope.studentAttendanceData.length; s++) {
                var schedule = $scope.studentAttendanceData[s];
                var newSchedule = newAttendanceByActivityScheduleID[schedule.activityScheduleID];
                if (!!newSchedule) {
                    var differs =
                        schedule.firstPeriodAttendanceTypeID !== newSchedule.firstPeriodAttendanceTypeID ||
                        schedule.firstPeriodAttendanceStatusID !== newSchedule.firstPeriodAttendanceStatusID ||
                        schedule.firstPeriodAttendanceTypeID !== newSchedule.firstPeriodAttendanceTypeID ||
                        schedule.secondPeriodAttendanceStatusID !== newSchedule.secondPeriodAttendanceStatusID ||
                        schedule.numberOfExcuses !== newSchedule.numberOfExcuses ||
                        schedule.firstPeriodFilled !== newSchedule.firstPeriodFilled ||
                        schedule.secondPeriodFilled !== newSchedule.secondPeriodFilled ||
                        schedule.firstPeriodWaitQueuePosition !== newSchedule.firstPeriodWaitQueuePosition ||
                        schedule.secondPeriodWaitQueuePosition !== newSchedule.secondPeriodWaitQueuePosition;

                    if (differs) {
                        $scope.studentAttendanceData[s] = newSchedule;
                    }
                }
            };

            excuseModal.onSave();

            $scope.isSaving = false;
        }, function (err) {
            $scope.isSaving = false;
        });
    }
}]);
